import { RANGES, useDashboard } from '../context/DashboardContext';
import VisitorKpiCard from '../components/kpi/VisitorKpiCard';
import ConversationKpiCard from '../components/kpi/ConversationKpiCard';
import LeadKpiCard from '../components/kpi/LeadKpiCard';
import ConversionRateKpiCard from '../components/kpi/ConversionRateKpiCard';
import AiResponseMetricCard from '../components/kpi/AiResponseMetricCard';
import EscalationRateCard from '../components/kpi/EscalationRateCard';
import ResponseTimeCard from '../components/kpi/ResponseTimeCard';
import AiUsageCostIndicator from '../components/kpi/AiUsageCostIndicator';
import EngagementTrendChart from '../components/charts/EngagementTrendChart';
import SupportResolutionChart from '../components/charts/SupportResolutionChart';
import CtaPerformanceChart from '../components/charts/CtaPerformanceChart';

export default function DashboardPage() {
  const { range, setRange } = useDashboard();
  return (
    <>
      <div className="d-flex flex-wrap align-items-end justify-content-between gap-2 mb-4">
        <div>
          <h1 className="h4 fw-bold mb-0">Dashboard</h1>
          <p className="text-muted small mb-0">Welcome back! Here&apos;s what&apos;s happening today.</p>
        </div>
        <div>
          <label htmlFor="cb-range" className="visually-hidden">Date range</label>
          <select id="cb-range" className="form-select form-select-sm" value={range} onChange={(e) => setRange(e.target.value)}>
            {RANGES.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
          </select>
        </div>
      </div>

      <div className="row g-3 mb-3 row-cols-1 row-cols-sm-2 row-cols-xl-5">
        <div className="col"><VisitorKpiCard /></div>
        <div className="col"><ConversationKpiCard /></div>
        <div className="col"><LeadKpiCard /></div>
        <div className="col"><ConversionRateKpiCard /></div>
        <div className="col"><AiResponseMetricCard /></div>
      </div>

      <div className="row g-3 mb-3">
        <div className="col-12 col-md-6 col-xl-4"><EscalationRateCard /></div>
        <div className="col-12 col-md-6 col-xl-4"><ResponseTimeCard /></div>
        <div className="col-12 col-xl-4"><AiUsageCostIndicator /></div>
      </div>

      <div className="row g-3">
        <div className="col-12 col-xl-7"><EngagementTrendChart /></div>
        <div className="col-12 col-xl-5"><SupportResolutionChart /></div>
      </div>

      <div className="row g-3 mt-0">
        <div className="col-12"><CtaPerformanceChart /></div>
      </div>
    </>
  );
}
